<template>
  <v-card>
    <v-overlay
      absolute
      opacity="0.8"
      :value="!hasData"
    >
      <span class="text-bold">
        Facebook not linked
      </span>
    </v-overlay>
    <v-card-title class="">
      Audience gender
    </v-card-title>
    <v-card-text>
      <v-progress-linear
        class="mb-2"
        :background-color="genderColors.female"
        :color="genderColors.female"
        :value="percentageFemale"
        height="24"
        rounded
        background-opacity="0.2"
      >
        <span class="text-bold female-linear">Female: {{ percentageFemale }}%</span>
      </v-progress-linear>
      <v-progress-linear
        rounded
        :background-color="genderColors.male"
        :color="genderColors.male"
        :value="percentageMale"
        height="24"
        background-opacity="0.2"
        reverse
      >
        Male: {{ percentageMale }}%
      </v-progress-linear>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const audienceGenderAgeData = props?.data;
    const genderColors = {
      male: '#4F5BD5',
      female: '#FCDCF3',
    };

    return {
      genderColors,
      percentageFemale: audienceGenderAgeData?.data?.count?.percentage?.female || 0,
      percentageMale: audienceGenderAgeData?.data?.count?.percentage?.male || 0,
      hasData: audienceGenderAgeData,
    };
  },
};
</script>

<style scoped lang="scss">
  .female-linear {
    color: black;
  }
</style>
